import * as THREE from 'three';

/**
 * Sky.js - container for all celestial objects.
 *
 * Owns a THREE.Group. Every star, planet, comet, etc. lives here.
 * Provides update(dt) which calls update on each child object.
 */
export class Sky {
  constructor(scene) {
    this.scene = scene;
    this.group = new THREE.Group();
    this.scene.add(this.group);
    this.objects = [];
    this.interactables = []; // for raycasting later
  }

  /**
   * Add a celestial object. Accepts either:
   *  - a Star instance (with .mesh and optional .update)
   *  - a raw THREE.Object3D
   */
  add(obj) {
    if (obj.mesh) {
      this.group.add(obj.mesh);
      if (obj.interactable) {
        const target = obj.clickTarget || obj.mesh;
        this.interactables.push(target);
        // If the click target is a separate object that isn't already
        // parented in the scene graph, add it to the sky group too - so
        // its world matrix gets updated when we call updateMatrixWorld.
        if (target !== obj.mesh && !target.parent) {
          this.group.add(target);
        }
      }
    } else {
      this.group.add(obj);
    }
    this.objects.push(obj);
  }

  remove(obj) {
    if (obj.mesh) {
      this.group.remove(obj.mesh);
      // Also clean up the interactables array if this was a clickable
      const target = obj.clickTarget || obj.mesh;
      const tIdx = this.interactables.indexOf(target);
      if (tIdx !== -1) this.interactables.splice(tIdx, 1);
    } else {
      this.group.remove(obj);
    }
    const idx = this.objects.indexOf(obj);
    if (idx !== -1) this.objects.splice(idx, 1);
  }

  update(dt) {
    for (const obj of this.objects) {
      if (typeof obj.update === 'function') {
        obj.update(dt);
      }
    }
  }
}
